import { useState, useEffect } from 'react';

export function useMasonryColumns<T>(items: T[]): T[][] {
  const [columns, setColumns] = useState<T[][]>([[], [], []]);

  useEffect(() => {
    const calculateColumns = () => {
      const width = window.innerWidth;
      let numCols: number;
      
      if (width < 768) {
        // Mobile: 1 column
        numCols = 1;
      } else if (width < 1024) {
        // iPad: 2 columns
        numCols = 2;
      } else {
        // Desktop: 3 columns
        numCols = 3;
      }
      
      const newCols: T[][] = Array.from({ length: numCols }, () => []);

      items.forEach((item, index) => {
        newCols[index % numCols].push(item);
      });

      setColumns(newCols);
    };

    calculateColumns();

    window.addEventListener('resize', calculateColumns);
    return () => window.removeEventListener('resize', calculateColumns);
  }, [items]);

  return columns;
}

